import React, { useState, useEffect } from 'react';

const DEFAULT_VLAN = { id: 10, name: 'vlan10', parent_interface: 'bridge1', subnet: '192.168.10.1/24', description: '' };

export default function StepVLAN({ data, onChange, onNext, onBack, interfaceNames }) {
  const [vlans, setVlans] = useState(data && data.length > 0 ? data : [{ ...DEFAULT_VLAN }]);

  useEffect(() => {
    if (data && data.length > 0) setVlans(data);
  }, [data]);

  const updateVlan = (index, key, value) => {
    const updated = [...vlans];
    updated[index] = { ...updated[index], [key]: value };
    if (key === 'id') updated[index].name = 'vlan' + value;
    setVlans(updated);
    onChange(updated);
  };

  const addVlan = () => {
    const nextId = Math.max(...vlans.map(v => v.id), 0) + 10;
    const updated = [...vlans, { ...DEFAULT_VLAN, id: nextId, name: 'vlan' + nextId, subnet: `192.168.${nextId}.1/24` }];
    setVlans(updated);
    onChange(updated);
  };

  const removeVlan = (index) => {
    if (vlans.length <= 1) return;
    const updated = vlans.filter((_, i) => i !== index);
    setVlans(updated);
    onChange(updated);
  };

  const vlanColors = ['bg-purple-500', 'bg-pink-500', 'bg-amber-500', 'bg-cyan-500', 'bg-lime-500', 'bg-rose-500'];

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">🔀 แบ่งเครือข่าย VLAN</h2>
        <p className="text-gray-500 dark:text-gray-400">แยกเครือข่ายออกเป็นส่วนย่อยๆ เพื่อความปลอดภัยและการจัดการที่ดีขึ้น</p>
      </div>

      <div className="space-y-4">
        {vlans.map((vlan, index) => (
          <div key={index} className="p-5 bg-gradient-to-br from-gray-50 to-white dark:from-gray-700/50 dark:to-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-600 shadow-sm">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <span className={`w-8 h-8 ${vlanColors[index % vlanColors.length]} text-white rounded-lg flex items-center justify-center text-sm font-bold shadow-md`}>{vlan.id}</span>
                <div>
                  <span className="font-bold text-gray-900 dark:text-white">{vlan.name}</span>
                  {vlan.description && <span className="ml-2 text-xs text-gray-400">— {vlan.description}</span>}
                </div>
              </div>
              <button onClick={() => removeVlan(index)} className="btn-danger" disabled={vlans.length <= 1}>ลบ</button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="label">VLAN ID (1-4094)</label>
                <input type="number" min="1" max="4094" value={vlan.id} onChange={e => updateVlan(index, 'id', parseInt(e.target.value))} className="input-field" />
              </div>
              <div>
                <label className="label">ชื่อ VLAN</label>
                <input type="text" value={vlan.name} onChange={e => updateVlan(index, 'name', e.target.value)} className="input-field" placeholder="vlan-staff" />
              </div>
              <div>
                <label className="label">Interface ต้นทาง</label>
                <select value={vlan.parent_interface} onChange={e => updateVlan(index, 'parent_interface', e.target.value)} className="input-field">
                  {(interfaceNames && interfaceNames.length > 0 ? interfaceNames : ['bridge1', 'bridge-lan', 'ether1', 'ether2', 'ether3', 'ether4', 'ether5', 'sfp-sfpplus1']).map(iface => (
                    <option key={iface} value={iface}>{iface}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="label">IP Subnet (Gateway/CIDR)</label>
                <input type="text" value={vlan.subnet} onChange={e => updateVlan(index, 'subnet', e.target.value)} className="input-field" placeholder="192.168.10.1/24" />
              </div>
              <div className="sm:col-span-2">
                <label className="label">คำอธิบาย (ไม่บังคับ)</label>
                <input type="text" value={vlan.description} onChange={e => updateVlan(index, 'description', e.target.value)} className="input-field" placeholder="เช่น เครือข่ายพนักงาน, เครือข่ายแขก" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <button onClick={addVlan} className="mt-4 px-4 py-3 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl text-gray-500 dark:text-gray-400 hover:border-purple-500 hover:text-purple-500 transition-colors w-full font-medium text-sm">
        + เพิ่ม VLAN
      </button>

      <div className="mt-4 p-3 bg-purple-50 dark:bg-purple-900/10 border border-purple-100 dark:border-purple-800/50 rounded-lg">
        <p className="text-xs text-purple-700 dark:text-purple-300">
          <strong>💡 เคล็ดลับ:</strong> แต่ละ VLAN จะถูกสร้างเป็น Interface แยกกัน พร้อม IP Gateway อัตโนมัติ สามารถตั้งค่า DHCP Server แยกให้แต่ละ VLAN ได้ในขั้นตอนถัดไป
        </p>
      </div>

      <div className="flex justify-between mt-6">
        <button onClick={onBack} className="btn-secondary">← ย้อนกลับ</button>
        <button onClick={onNext} className="btn-primary">ถัดไป ({vlans.length} VLAN)</button>
      </div>
    </div>
  );
}
